import { ReactNode } from 'react'
import { TDeviceType } from 'shared/types'
import { LoraDeviceKeys } from './LoraDeviceKeys'
import { LoraGatewayKeys } from './LoraGatewayKeys'
import { SnmpKeys } from './SnmpKeys'

const Unsupported = () => <div>Unsupported</div>

const DeviceKeysMap: Record<TDeviceType, ReactNode> = {
  LoraDevice: <LoraDeviceKeys />,
  LoraGateway: <LoraGatewayKeys />,
  SNMP: <SnmpKeys />,
  MQTT: <Unsupported />,
  UnKnown: <Unsupported />,
}

export default DeviceKeysMap
